import React, { Component } from 'react'
import { relativizeURL, decode } from 'lib/Utils'
import { Link } from 'react-router'
import EntryDate from 'components/EntryDate'
import { TweenMax, Power0 } from 'gsap'
import EntryListItem from 'components/EntryListItem'
import PropTypes from 'prop-types'
import './index.scss'

const Entities = require('html-entities').XmlEntities
const entities = new Entities()

class Entry extends Component {
  componentWillEnter (callback) {
    const el = this.el
    TweenMax.fromTo(
      el,
      0.4,
      { opacity: '0' },
      { opacity: '1', ease: Power0.easeNone, onComplete: callback, delay: 1 },
    )
  }

  componentWillLeave (callback) {
    const el = this.el
    TweenMax.to(
      el,
      0.4,
      { opacity: '0', ease: Power0.easeNone, onComplete: callback },
    )
  }

  createContentMarkup () {
    let item = this.props.item
    return { __html: item.content.rendered }
  }

  renderRelated () {
    const related = this.props.item.related
    return related.map((relatedItem) => {
      return <EntryListItem key={relatedItem.id} item={relatedItem} />
    })
  }

  render () {
    let item = this.props.item

    return (
      <div ref={el => { this.el = el }}>
        <article className='entry'>
          <div className='entry__inner'>
            <div className='entry__meta'>
              <EntryDate date={item.date} />
              <div className='entry__term small-title'>{item._embedded['wp:term'][0][0].name}</div>
            </div>
            <h1>{decode(item.title.rendered)}</h1>
            <div className='entry__content content' dangerouslySetInnerHTML={this.createContentMarkup()} />
            <h3 className='lined-title'>
              <span />
              More News
            </h3>
          </div>
          <div className='entry__related'>
            <ul className='items-list'>{this.renderRelated()}</ul>
          </div>
        </article>
      </div>
    )
  }
}

Entry.propTypes = {
  item: PropTypes.object
}

export default Entry



// WEBPACK FOOTER //
// ./src/components/Entry/index.js